<template>
  <div class="sidebar-container">
    <!-- <div class="logo-container">
      <div class="logo">
        <router-link to="/">
          <img
            src="../../assets/Shuttle_Logo.png"
            alt="shuttle-logo"
            width="123"
            height="26"
            class="d-inline-block align-text-top logo"
          />
        </router-link>
      </div>
    </div> -->
    <div class="nav">
      <ul>
        <!-- <li class="menu-item">
          <router-link
            to="/trip-request/trip/create"
            :class="{
              'nav-link': true,
              'router-link-active': menus['trip-create']
            }"
            >Create Trip Request
          </router-link>
        </li> -->
        <li v-if="permissions.includes('dashboard')" class="menu-item">
          <router-link
            to="/dashboard"
            :class="{
              'nav-link': true,
              'router-link-active': menus['dashboard']
            }"
            ><i class="bi bi-speedometer2"></i><span>Dashboard</span>
          </router-link>
        </li>
        <li v-if="permissions.includes('trip-request')" class="menu-item">
          <router-link
            to="/trip-request/vehicle/requests"
            :class="{
              'nav-link': true,
              'router-link-active': menus['trip-request']
            }"
            ><i class="bi bi-cone-striped"></i><span>Trip Request</span>
          </router-link>
        </li>
        <li v-if="permissions.includes('partners')" class="menu-item">
          <router-link
            to="/trip-request/partners"
            :class="{
              'nav-link': true,
              'router-link-active': menus['partners']
            }"
            ><i class="bi bi-person-lines-fill"></i><span>Partners</span>
          </router-link>
        </li>
        <li v-if="permissions.includes('assigned-partners')" class="menu-item">
          <router-link
            to="/trip-request/assigned-partners"
            :class="{
              'nav-link': true,
              'router-link-active': menus['assigned-partners']
            }"
            ><i class="bi bi-list-ul"></i><span>Assigned List</span>
          </router-link>
        </li>
        <li
          v-if="permissions.includes('partners-attendance')"
          class="menu-item"
        >
          <router-link
            to="/trip-request/partners-attendance"
            :class="{
              'nav-link': true,
              'router-link-active': menus['partners-attendance']
            }"
            ><i class="bi bi-clipboard-check"></i><span>Attendance</span>
          </router-link>
        </li>
        <li
          v-if="permissions.includes('partner-location-list')"
          class="menu-item"
        >
          <router-link
            to="/trip-request/partner-location-list"
            :class="{
              'nav-link': true,
              'router-link-active': menus['partner-location-list']
            }"
            ><i class="bi bi-geo-alt-fill"></i><span>Partner Locations</span>
          </router-link>
        </li>
        <li
          v-if="permissions.includes('partner-permission-list')"
          class="menu-item"
        >
          <router-link
            to="/trip-request/partner/permission/list"
            :class="{
              'nav-link': true,
              'router-link-active': menus['partner-permission-list']
            }"
            ><i class="bi bi-key-fill"></i><span>Permission</span>
          </router-link>
        </li>
        <li v-if="permissions.includes('settings')" class="menu-item">
          <a
            :class="{
              'nav-link': true
              // 'router-link-active': subMenuShow.settings
            }"
            @click="subMenuShow.settings = !subMenuShow.settings"
          >
            <i class="bi bi-gear-fill"></i
            ><span
              >Settings
              <i
                v-if="!subMenuShow.settings"
                class="menu-arrow bi bi-chevron-right"
              ></i>
              <i
                v-if="subMenuShow.settings"
                class="menu-arrow bi bi-chevron-down"
              ></i>
            </span>
          </a>
          <ul
            :class="{
              'sub-menus': true,
              'sub-level-1': true,
              'display-hide': !subMenuShow.settings
            }"
          >
            <li v-if="permissions.includes('locations')" class="menu-item">
              <a
                :class="{
                  'nav-link': true
                  // 'router-link-active': subMenuShow.locations
                }"
                @click="subMenuShow.locations = !subMenuShow.locations"
                ><i class="bi bi-compass"></i
                ><span>
                  Locations
                  <i
                    v-if="!subMenuShow.locations"
                    class="menu-arrow bi bi-chevron-right"
                  ></i>
                  <i
                    v-if="subMenuShow.locations"
                    class="menu-arrow bi bi-chevron-down"
                  ></i
                ></span>
              </a>
              <ul
                :class="{
                  'sub-menus': true,
                  'sub-level-2': true,
                  'display-hide': !subMenuShow.locations
                }"
              >
                <li
                  v-if="permissions.includes('city-settings')"
                  class="menu-item"
                >
                  <router-link class="dropdown-item" to="/settings/city"
                    ><i class="bi bi-building"></i
                    ><span>City</span></router-link
                  >
                </li>
                <li
                  v-if="permissions.includes('area-settings')"
                  class="menu-item"
                >
                  <router-link class="dropdown-item" to="/settings/area"
                    ><i class="bi bi-globe"></i><span>Area</span></router-link
                  >
                </li>
              </ul>
            </li>
            <li
              v-if="permissions.includes('car-type-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/car/type"
                ><i
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    fill="currentColor"
                    class="bi bi-truck-front"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7ZM4 2a1 1 0 0 0-1 1v3.9c0 .625.562 1.092 1.17.994C5.075 7.747 6.792 7.5 8 7.5c1.208 0 2.925.247 3.83.394A1.008 1.008 0 0 0 13 6.9V3a1 1 0 0 0-1-1H4Zm0 1h8v3.9c0 .002 0 .001 0 0l-.002.004a.013.013 0 0 1-.005.002h-.004C11.088 6.761 9.299 6.5 8 6.5s-3.088.26-3.99.406h-.003a.013.013 0 0 1-.005-.002L4 6.9c0 .001 0 .002 0 0V3Z"
                    />
                    <path
                      d="M1 2.5A2.5 2.5 0 0 1 3.5 0h9A2.5 2.5 0 0 1 15 2.5v9c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.496 2.496 0 0 1-1-2v-9ZM3.5 1A1.5 1.5 0 0 0 2 2.5v9A1.5 1.5 0 0 0 3.5 13h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 1h-9Z"
                    /></svg></i
                ><span>Car Type</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('car-brand-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/car/brand"
                ><i
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    fill="currentColor"
                    class="bi bi-car-front"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM4.862 4.276 3.906 6.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17 1.247 0 2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 4H5.309a.5.5 0 0 0-.447.276Z"
                    />
                    <path
                      d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM4.82 3a1.5 1.5 0 0 0-1.379.91l-.792 1.847a1.8 1.8 0 0 1-.853.904.807.807 0 0 0-.43.564L1.03 8.904a1.5 1.5 0 0 0-.03.294v.413c0 .796.62 1.448 1.408 1.484 1.555.07 3.786.155 5.592.155 1.806 0 4.037-.084 5.592-.155A1.479 1.479 0 0 0 15 9.611v-.413c0-.099-.01-.197-.03-.294l-.335-1.68a.807.807 0 0 0-.43-.563 1.807 1.807 0 0 1-.853-.904l-.792-1.848A1.5 1.5 0 0 0 11.18 3H4.82Z"
                    /></svg></i
                ><span>Car Brand</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('trip-type-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/trip/type"
                ><i
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-airplane"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Zm.894.448C7.111 2.02 7 2.569 7 3v4a.5.5 0 0 1-.276.447l-5.448 2.724a.5.5 0 0 0-.276.447v.792l5.418-.903a.5.5 0 0 1 .575.41l.5 3a.5.5 0 0 1-.14.437L6.708 15h2.586l-.647-.646a.5.5 0 0 1-.14-.436l.5-3a.5.5 0 0 1 .576-.411L15 11.41v-.792a.5.5 0 0 0-.276-.447L9.276 7.447A.5.5 0 0 1 9 7V3c0-.432-.11-.979-.322-1.401C8.458 1.159 8.213 1 8 1c-.213 0-.458.158-.678.599Z"
                    /></svg></i
                ><span>Trip Type</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('preset-remarks-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/preset-remarks"
                ><i class="bi bi-blockquote-left"></i
                ><span>Preset Remarks</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('call-notes-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/call-notes"
                ><i class="bi bi-journal-arrow-down"></i
                ><span>Call Notes</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('promo-banner-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/promo-banner"
                ><i class="bi bi-image"></i
                ><span>Promo Banner</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('promotional-video-settings')"
              class="menu-item"
            >
              <router-link
                class="dropdown-item"
                to="/settings/promotional-video"
                ><i class="bi bi-camera-reels"></i
                ><span>Promotional Video</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('email-template-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/email-template"
                ><i class="bi bi-envelope"></i
                ><span>Email Template</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('holiday-calendar-settings')"
              class="menu-item"
            >
              <router-link class="dropdown-item" to="/settings/holiday-calendar"
                ><i class="bi bi-calendar-minus-fill"></i
                ><span>Holiday Calculation</span></router-link
              >
            </li>
            <li
              v-if="permissions.includes('backup-settings')"
              class="menu-item"
            >
              <a
                :class="{
                  'nav-link': true
                }"
                @click="subMenuShow.backup = !subMenuShow.backup"
                ><i class="bi bi-back"></i><span>
                  Backup
                  <i
                    v-if="!subMenuShow.backup"
                    class="menu-arrow bi bi-chevron-right"
                  ></i>
                  <i
                    v-if="subMenuShow.backup"
                    class="menu-arrow bi bi-chevron-down"
                  ></i
                ></span>
              </a>
              <ul
                :class="{
                  'sub-menus': true,
                  'sub-level-2': true,
                  'display-hide': !subMenuShow.backup
                }"
              >
                <li
                  v-if="permissions.includes('trip-percentage-settings')"
                  class="menu-item"
                >
                  <router-link
                    class="dropdown-item"
                    to="/settings/trip-percentage"
                    ><i class="bi bi-percent"></i
                    ><span>Trip Percentage</span></router-link
                  >
                </li>
                <li
                  v-if="permissions.includes('distance-settings')"
                  class="menu-item"
                >
                  <router-link class="dropdown-item" to="/settings/distance"
                    ><i class="bi bi-binoculars"></i><span>Distance</span></router-link
                  >
                </li>
                <li
                  v-if="permissions.includes('time-settings')"
                  class="menu-item"
                >
                  <router-link class="dropdown-item" to="/settings/time"
                    ><i class="bi bi-alarm"></i><span>Time</span></router-link
                  >
                </li>
                <li
                  v-if="permissions.includes('cancel-hide-settings')"
                  class="menu-item"
                >
                  <router-link class="dropdown-item" to="/settings/cancel/hide"
                    ><i class="bi bi-x-circle"></i><span>Cancel Hide</span></router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { activeMenus } from '../../store/navActiveMenu';
export default {
  name: 'TheSidebar',
  data() {
    return {
      menus: activeMenus.menus,
      subMenuShow: {
        settings: false,
        locations: false,
        backup:false
      },
      permissions: localStorage.getItem('userPermission')
        ? localStorage.getItem('userPermission').split(',')
        : []
    };
  },
  mounted() {
    this.refreshPageMenus();
  },
  watch: {
    $route() {
      this.refreshPageMenus();
    }
  },
  methods: {
    refreshPageMenus() {
      if (!this.subMenuShow.locations) {
        this.subMenuShow.locations = this.menus['locations'];
      }
      if (!this.subMenuShow.backup) {
        this.subMenuShow.backup = this.menus['backup'];
      }
      if (!this.subMenuShow.settings) {
        this.subMenuShow.settings = this.menus['settings'];
      }
    }
  }
};
</script>

<style scoped>
.sidebar-container {
  padding: 0 11px;
}
.logo-container {
  height: 75px;
  display: table-cell;
  vertical-align: middle;
}
.nav {
  margin-top: 96px;
}
.nav ul {
  padding: 0;
  width: 100%;
}
.nav ul li {
  list-style: none;
  overflow: hidden;
  margin-bottom: 8px;
}
.nav ul li:last-child {
  border-bottom: 1px solid rgba(256, 256, 256, 0.2);
}
.menu-item a {
  color: #6b7280;
  font-size: 16px;
  white-space: nowrap;
  padding: 0;
  display: flex;
  align-items: center;
  height: 48px;
  min-width: 210px;
  border-radius: 8px;
}
.menu-item a:hover {
  background: #652f8f;
  color: white;
}
.menu-item a span {
  width: 100%;
}
.menu-item a span i {
  padding: 0 8px;
}
.menu-item a > i {
  font-size: 20px;
  width: 16.67px;
  margin-right: 9.67px;
  margin-left: 13.67px;
}

.router-link-active {
  background: #652f8f;
  color: white !important;
}
.sub-menus {
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
}
.sub-menus li:last-child {
  border-bottom: none !important;
}
.sub-menus li a {
  font-size: 13px;
  padding: 0;
  line-height: 44px;
}
.sub-menus li a > i {
  font-size: 19px;
}

.sub-level-1 > li > a {
  padding-left: 30px !important;
}
.sub-level-2 > li > a {
  padding-left: 50px !important;
}
.menu-arrow {
  float: right;
}
.display-hide {
  display: none;
}

.active {
  background: #652f8f;
  color: white !important;
}
</style>
